

(function () {


  var AWPD = {

    email:
      "info@artworxprint.com",


    products: {


      tshirt: {

        name:
          "T-Shirt",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/More_Apparel.png?v=1787866024",

        defaultPlacement:
          "center_front"

      },


      polo: {

        name:
          "Polo",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/Polos.png?v=1787866024",

        defaultPlacement:
          "left_chest"

      },


      hoodie: {

        name:
          "Hoodie",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/Hoodies.png?v=1787866023",

        defaultPlacement:
          "center_front"

      },


      hat: {

        name:
          "Hat",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/Hats.png?v=1787866023",

        defaultPlacement:
          "hat_front"

      },


      workwear: {

        name:
          "Workwear",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/Workwear.png?v=1787866023",

        defaultPlacement:
          "left_chest"

      },


      jacket: {

        name:
          "Jacket",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/Jackets.png?v=1787866023",

        defaultPlacement:
          "left_chest"

      },


      more: {

        name:
          "More Apparel",

        image:
          "https://cdn.shopify.com/s/files/1/2248/5611/files/More_Apparel.png?v=1787866024",

        defaultPlacement:
          "center_front"

      }


    },


    placements: {


      center_front: {

        name:
          "Center Front",

        label:
          'CENTER FRONT — STANDARD 12"',

        dimension:
          "width",

        standardMax:
          12,

        absoluteMax:
          16,

        min:
          2,

        step:
          .25,

        helper:
          'Standard center-front printing goes up to 12" wide. Sizes above 12" are considered large prints and may be priced higher.',

        zone: {

          top:
            29,

          left:
            33,

          width:
            34,

          height:
            32

        }

      },


      left_chest: {

        name:
          "Left Chest",

        label:
          'LEFT CHEST MAX 4"',

        dimension:
          "width",

        standardMax:
          4,

        absoluteMax:
          4,

        min:
          1,

        step:
          .25,

        helper:
          'Left chest decoration is limited to a maximum width of 4".',

        zone: {

          top:
            24,

          left:
            34,

          width:
            14,

          height:
            14

        }

      },


      right_chest: {

        name:
          "Right Chest",

        label:
          'RIGHT CHEST MAX 4"',

        dimension:
          "width",

        standardMax:
          4,

        absoluteMax:
          4,

        min:
          1,

        step:
          .25,

        helper:
          'Right chest decoration is limited to a maximum width of 4".',

        zone: {

          top:
            24,

          left:
            52,

          width:
            14,

          height:
            14

        }

      },


      sleeve_left: {

        name:
          "Left Sleeve",

        label:
          'LEFT SLEEVE MAX 2" HIGH',

        dimension:
          "height",

        standardMax:
          2,

        absoluteMax:
          2,

        min:
          .5,

        step:
          .25,

        helper:
          'Sleeve decoration is limited to a maximum height of 2".',

        zone: {

          top:
            29,

          left:
            14,

          width:
            11,

          height:
            15

        }

      },


      sleeve_right: {

        name:
          "Right Sleeve",

        label:
          'RIGHT SLEEVE MAX 2" HIGH',

        dimension:
          "height",

        standardMax:
          2,

        absoluteMax:
          2,

        min:
          .5,

        step:
          .25,

        helper:
          'Sleeve decoration is limited to a maximum height of 2".',

        zone: {

          top:
            29,

          left:
            75,

          width:
            11,

          height:
            15

        }

      },


      hat_front: {

        name:
          "Hat Front",

        label:
          'HAT FRONT MAX 4.5"',

        dimension:
          "width",

        standardMax:
          4.5,

        absoluteMax:
          4.5,

        min:
          1,

        step:
          .25,

        helper:
          'Hat decoration area varies by cap style. Requested artwork is subject to Artworx review.',

        zone: {

          top:
            38,

          left:
            34,

          width:
            32,

          height:
            18

        }

      }


    }


  };


  var catalogNode = document.getElementById("awpd-product-data");
  if (catalogNode) {
    try {
      var catalogProducts = JSON.parse(catalogNode.textContent);
      Object.keys(catalogProducts).forEach(function (key) {
        AWPD.products[key] = catalogProducts[key];
      });
    } catch (error) {
      console.warn("Artworx designer product data could not be loaded.", error);
    }
  }
  AWPD.products.tshirt.image = window.AWPD_WHITE_TEE_URL || AWPD.products.tshirt.image;

  var state = {

    product:
      "tshirt",

    color:
      "",

    method:
      "print",

    placement:
      "center_front",

    requestedSize:
      8,

    quantity:
      24,

    sizeQuantities: {
      S: 0,
      M: 0,
      L: 24,
      XL: 0,
      "2XL": 0,
      "3XL": 0,
      "4XL": 0,
      Other: 0
    },

    artworkUrl:
      "",

    artworkFileName:
      "",

    artRatio:
      1,

    artX:
      .5,

    artY:
      .5

  };


  var els = {

    product:
      document.getElementById(
        "awpd-product"
      ),

    color:
      document.getElementById(
        "awpd-color"
      ),

    methodRadios:
      document.querySelectorAll(
        'input[name="awpd-method"]'
      ),

    placementOptions:
      document.getElementById(
        "awpd-placement-options"
      ),

    placementHelper:
      document.getElementById(
        "awpd-placement-helper"
      ),

    embWarning:
      document.getElementById(
        "awpd-emb-warning"
      ),

    sizeRange:
      document.getElementById(
        "awpd-size-range"
      ),

    sizeValue:
      document.getElementById(
        "awpd-size-value"
      ),

    sizeTitle:
      document.getElementById(
        "awpd-size-title"
      ),

    sizeHelper:
      document.getElementById(
        "awpd-size-helper"
      ),

    pricingNote:
      document.getElementById(
        "awpd-pricing-note"
      ),

    sizeQtyInputs:
      document.querySelectorAll(
        ".awpd-size-qty"
      ),

    upload:
      document.getElementById(
        "awpd-upload"
      ),

    notes:
      document.getElementById(
        "awpd-notes"
      ),

    productImage:
      document.getElementById(
        "awpd-product-image"
      ),

    zone:
      document.getElementById(
        "awpd-zone"
      ),

    zoneLabel:
      document.getElementById(
        "awpd-zone-label"
      ),

    artworkWrap:
      document.getElementById(
        "awpd-artwork-wrap"
      ),

    artwork:
      document.getElementById(
        "awpd-artwork"
      ),

    resizeHandle:
      document.getElementById(
        "awpd-resize-handle"
      ),

    previewSummary:
      document.getElementById(
        "awpd-preview-summary"
      ),

    summaryList:
      document.getElementById(
        "awpd-summary-list"
      ),

    summaryText:
      document.getElementById(
        "awpd-summary-text"
      ),

    emailBtn:
      document.getElementById(
        "awpd-email-btn"
      ),

    resetBtn:
      document.getElementById(
        "awpd-reset-btn"
      ),

    name:
      document.getElementById(
        "awpd-name"
      ),

    company:
      document.getElementById(
        "awpd-company"
      ),

    email:
      document.getElementById(
        "awpd-email"
      ),

    phone:
      document.getElementById(
        "awpd-phone"
      )

  };


  function getAllowedPlacements() {

    if (
      state.product ===
      "hat"
    ) {

      return [
        "hat_front"
      ];

    }


    if (
      state.method ===
      "embroidery"
    ) {

      return [
        "left_chest",
        "right_chest",
        "sleeve_left",
        "sleeve_right"
      ];

    }


    return [
      "center_front",
      "left_chest",
      "right_chest",
      "sleeve_left",
      "sleeve_right"
    ];

  }



  function buildPlacementOptions() {

    var allowed =
      getAllowedPlacements();


    if (
      allowed.indexOf(
        state.placement
      ) ===
      -1
    ) {

      state.placement =
        AWPD.products[
          state.product
        ].defaultPlacement;


      if (
        allowed.indexOf(
          state.placement
        ) ===
        -1
      ) {

        state.placement =
          allowed[0];

      }

    }


    var html =
      "";


    allowed.forEach(
      function (key) {

        var placement =
          AWPD.placements[
            key
          ];


        html +=

          '<div class="awpd-placement">' +

            '<input ' +
              'type="radio" ' +
              'name="awpd-placement" ' +
              'id="awpd-placement-' +
              key +
              '" ' +
              'value="' +
              key +
              '"' +
              (
                state.placement === key
                  ? ' checked'
                  : ''
              ) +
            '>' +

            '<label for="awpd-placement-' +
              key +
            '">' +
              placement.name +
            '</label>' +

          '</div>';

      }
    );


    els.placementOptions.innerHTML =
      html;


    els.placementOptions
      .querySelectorAll(
        'input[name="awpd-placement"]'
      )
      .forEach(
        function (input) {

          input.addEventListener(
            "change",
            function () {

              state.placement =
                this.value;


              resetArtworkPosition();

              syncSizeToPlacement();

              renderAll();

            }
          );

        }
      );

  }



  function syncSizeToPlacement() {

    var placement =
      AWPD.placements[
        state.placement
      ];


    if (
      state.requestedSize <
      placement.min
      ||
      state.requestedSize >
      placement.absoluteMax
    ) {

      if (
        placement.standardMax >=
        8
      ) {

        state.requestedSize =
          8;

      }

      else {

        state.requestedSize =
          placement.standardMax;

      }

    }


    els.sizeRange.min =
      placement.min;


    els.sizeRange.max =
      placement.absoluteMax;


    els.sizeRange.step =
      placement.step;


    els.sizeRange.value =
      state.requestedSize;


    if (
      placement.dimension ===
      "height"
    ) {

      els.sizeTitle.textContent =
        "Artwork Height";


      els.sizeValue.textContent =
        state.requestedSize +
        '" H';

    }

    else {

      els.sizeTitle.textContent =
        "Artwork Width";


      els.sizeValue.textContent =
        state.requestedSize +
        '"';

    }


    els.sizeHelper.textContent =
      placement.helper;

  }



  function updateEmbroideryWarning() {

    if (
      state.method ===
      "embroidery"
    ) {

      els.embWarning.classList.add(
        "awpd-warning-active"
      );

    }

    else {

      els.embWarning.classList.remove(
        "awpd-warning-active"
      );

    }

  }



  function getColorOptionIndex(product) {

    if (!product || !product.options) return -1;

    for (var i = 0; i < product.options.length; i++) {
      var optionName = String(product.options[i].name || product.options[i]).toLowerCase();
      if (optionName.indexOf("color") > -1 || optionName.indexOf("colour") > -1) {
        return i;
      }
    }

    return -1;

  }


  function buildColorOptions() {

    var product = AWPD.products[state.product];
    var colorIndex = getColorOptionIndex(product);
    var colors = [];

    if (product && product.variants && colorIndex > -1) {
      product.variants.forEach(function (variant) {
        var color = variant.options && variant.options[colorIndex];
        if (color && colors.indexOf(color) === -1) colors.push(color);
      });
    }

    els.color.innerHTML = "";

    if (!colors.length) {
      var defaultOption = document.createElement("option");
      defaultOption.value = "";
      defaultOption.textContent = "Default Color";
      els.color.appendChild(defaultOption);
      els.color.disabled = true;
      state.color = "";
      return;
    }

    els.color.disabled = false;
    colors.forEach(function (color) {
      var option = document.createElement("option");
      option.value = color;
      option.textContent = color;
      els.color.appendChild(option);
    });

    if (colors.indexOf(state.color) === -1) state.color = colors[0];
    els.color.value = state.color;

  }


  function updateProductImage() {

    var product = AWPD.products[state.product];
    var productImage = product.image;
    var colorIndex = getColorOptionIndex(product);

    if (state.color && product.variants && colorIndex > -1) {
      var matchingVariant = product.variants.find(function (variant) {
        return variant.options && variant.options[colorIndex] === state.color && variant.featured_image;
      });

      if (matchingVariant && matchingVariant.featured_image) {
        productImage = matchingVariant.featured_image.src || matchingVariant.featured_image;
      }
    }

    els.productImage.src = productImage;


    els.productImage.alt =
      product.name + (state.color ? " - " + state.color : "");

  }



  function updateZone() {

    var placement =
      AWPD.placements[
        state.placement
      ];


    var zone =
      placement.zone;


    els.zone.style.top =
      zone.top +
      "%";


    els.zone.style.left =
      zone.left +
      "%";


    els.zone.style.width =
      zone.width +
      "%";


    els.zone.style.height =
      zone.height +
      "%";


    els.zoneLabel.textContent =
      placement.label;


    els.placementHelper.textContent =
      placement.helper;

  }



  function updateArtworkSize() {

    if (
      !state.artworkUrl
    ) {

      els.artworkWrap.classList.add(
        "awpd-hidden"
      );


      return;

    }


    var placement =
      AWPD.placements[
        state.placement
      ];


    var zoneWidth =
      els.zone.clientWidth;


    var zoneHeight =
      els.zone.clientHeight;


    if (
      !zoneWidth ||
      !zoneHeight
    ) {

      return;

    }


    var ratio =
      state.artRatio ||
      1;


    var scale =
      (
        state.requestedSize -
        placement.min
      )
      /
      (
        placement.absoluteMax -
        placement.min ||
        1
      );


    scale =
      Math.max(
        0,
        Math.min(
          1,
          scale
        )
      );


    var minVisual =
      .35;


    var visualScale =
      minVisual +
      scale *
      (
        1 -
        minVisual
      );


    var targetWidth =
      zoneWidth *
      visualScale;


    var targetHeight =
      targetWidth /
      ratio;


    if (
      placement.dimension ===
      "height"
    ) {

      targetHeight =
        zoneHeight *
        visualScale;


      targetWidth =
        targetHeight *
        ratio;

    }


    if (
      targetWidth >
      zoneWidth
    ) {

      targetWidth =
        zoneWidth;


      targetHeight =
        targetWidth /
        ratio;

    }


    if (
      targetHeight >
      zoneHeight
    ) {

      targetHeight =
        zoneHeight;


      targetWidth =
        targetHeight *
        ratio;

    }


    els.artworkWrap.style.width =
      targetWidth +
      "px";


    els.artworkWrap.style.height =
      targetHeight +
      "px";


    var maxLeft =
      Math.max(
        0,
        zoneWidth -
        targetWidth
      );


    var maxTop =
      Math.max(
        0,
        zoneHeight -
        targetHeight
      );


    els.artworkWrap.style.left =
      (
        maxLeft *
        state.artX
      ) +
      "px";


    els.artworkWrap.style.top =
      (
        maxTop *
        state.artY
      ) +
      "px";


    els.artworkWrap.classList.remove(
      "awpd-hidden"
    );

  }



  function getPricingNote() {

    var placement =
      AWPD.placements[
        state.placement
      ];


    if (
      state.method ===
      "embroidery"
    ) {

      return (
        "Embroidery selected. " +
        "Final embroidery pricing depends on artwork suitability, stitch count, garment type and placement."
      );

    }


    if (
      state.requestedSize >
      placement.standardMax
    ) {

      return (
        "Large print selected. " +
        "Requested size exceeds the standard print size and may have additional pricing."
      );

    }


    return (
      "Standard " +
      placement.name.toLowerCase() +
      " production size."
    );

  }



  function updatePricingBox() {

    var placement =
      AWPD.placements[
        state.placement
      ];


    if (
      state.method ===
      "embroidery"
    ) {

      els.pricingNote.innerHTML =
        '<strong>Embroidery Notice:</strong> ' +
        'Not all artwork can be embroidered. ' +
        'Artworx will review the design and contact the customer if changes are required.';

    }

    else if (
      placement.dimension ===
      "height"
    ) {

      els.pricingNote.innerHTML =
        'Sleeve decoration is limited to ' +
        '<strong>2" high</strong>.';

    }

    else if (
      placement.standardMax ===
      4
    ) {

      els.pricingNote.innerHTML =
        placement.name +
        ' is limited to a maximum of ' +
        '<strong>4" wide</strong>.';

    }

    else {

      els.pricingNote.innerHTML =
        'Standard front printing goes up to ' +
        '<strong>12" wide</strong>. ' +
        'Sizes above 12" are considered ' +
        '<strong>large prints</strong> and may have additional pricing.';

    }

  }



  function getSizeBreakdown() {

    var parts = [];
    var total = 0;

    Object.keys(state.sizeQuantities).forEach(
      function (size) {
        var qty = parseInt(state.sizeQuantities[size], 10) || 0;
        if (qty > 0) {
          parts.push(size + ": " + qty);
          total += qty;
        }
      }
    );

    state.quantity = total;

    return {
      total: total,
      text: parts.length ? parts.join(", ") : "No sizes entered"
    };

  }


  function updateSummaries() {

    var productName =
      AWPD.products[
        state.product
      ].name;

    var productDisplayName =
      productName +
      (state.color ? " / " + state.color : "");


    var placement =
      AWPD.placements[
        state.placement
      ];


    var placementName =
      placement.name;


    var methodName =
      state.method ===
      "embroidery"
        ? "Embroidery"
        : "Print";


    var sizeText =
      placement.dimension ===
      "height"
        ? state.requestedSize +
          '" H'
        : state.requestedSize +
          '"';


    var pricingNote =
      getPricingNote();

    var sizeBreakdown =
      getSizeBreakdown();


    els.previewSummary.innerHTML =

      '<div class="awpd-preview-stat"><span>Product</span><strong>' + productDisplayName + '</strong></div>' +
      '<div class="awpd-preview-stat"><span>Method</span><strong>' + methodName + '</strong></div>' +
      '<div class="awpd-preview-stat"><span>Placement</span><strong>' + placementName + '</strong></div>' +
      '<div class="awpd-preview-stat"><span>Size</span><strong>' + sizeText + '</strong></div>' +
      '<div class="awpd-preview-stat"><span>Quantity</span><strong>' + sizeBreakdown.total + '</strong></div>';


    els.summaryList.innerHTML =

      '<li><strong>Product:</strong> ' +
      productName +
      '</li>' +

      '<li><strong>Color:</strong> ' +
      (state.color || "Default") +
      '</li>' +

      '<li><strong>Method:</strong> ' +
      methodName +
      '</li>' +

      '<li><strong>Placement:</strong> ' +
      placementName +
      '</li>' +

      '<li><strong>Requested Size:</strong> ' +
      sizeText +
      '</li>' +

      '<li><strong>Quantity:</strong> ' +
      sizeBreakdown.total +
      '</li>' +

      '<li><strong>Garment Sizes:</strong> ' +
      sizeBreakdown.text +
      '</li>' +

      '<li><strong>Artwork:</strong> ' +
      (
        state.artworkFileName
          ? state.artworkFileName
          : "Not uploaded"
      ) +
      '</li>' +

      '<li><strong>Pricing Note:</strong> ' +
      pricingNote +
      '</li>';


    var summaryText =

      'ARTWORX PUBLIC DESIGNER REQUEST\n' +

      '---------------------------------\n' +

      'Product: ' +
      productName +
      '\n' +

      'Color: ' +
      (state.color || "Default") +
      '\n' +

      'Decoration Method: ' +
      methodName +
      '\n' +

      'Placement: ' +
      placementName +
      '\n' +

      'Requested Size: ' +
      sizeText +
      '\n' +

      'Quantity: ' +
      sizeBreakdown.total +
      '\n' +

      'Garment Sizes: ' +
      sizeBreakdown.text +
      '\n' +

      'Uploaded Artwork: ' +
      (
        state.artworkFileName
          ? state.artworkFileName
          : "No artwork uploaded"
      ) +
      '\n' +

      'Pricing Note: ' +
      pricingNote +
      '\n\n' +

      'Design Notes:\n' +
      (
        els.notes.value ||
        "None provided."
      );


    els.summaryText.value =
      summaryText;

  }



  function renderAll() {

    updateEmbroideryWarning();

    updateProductImage();

    updateZone();

    syncSizeToPlacement();

    updateArtworkSize();

    updatePricingBox();

    updateSummaries();

  }



  function resetArtworkPosition() {

    state.artX =
      .5;


    state.artY =
      .5;

  }



  function handleUpload(file) {

    if (!file) {

      return;

    }


    state.artworkFileName =
      file.name;


    var reader =
      new FileReader();


    reader.onload =
      function (event) {

        state.artworkUrl =
          event.target.result;


        els.artwork.src =
          state.artworkUrl;


        var tempImage =
          new Image();


        tempImage.onload =
          function () {

            state.artRatio =
              tempImage.width /
              tempImage.height ||
              1;


            resetArtworkPosition();

            updateArtworkSize();

            updateSummaries();

          };


        tempImage.src =
          state.artworkUrl;

      };


    reader.readAsDataURL(
      file
    );

  }



  function loadProofImage(src) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = function () { resolve(image); };
      image.onerror = reject;
      image.src = src;
    });
  }


  function drawContained(context, image, x, y, width, height) {
    var scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
    var drawWidth = image.naturalWidth * scale;
    var drawHeight = image.naturalHeight * scale;
    var drawX = x + (width - drawWidth) / 2;
    var drawY = y + (height - drawHeight) / 2;
    context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
    return { x: drawX, y: drawY, width: drawWidth, height: drawHeight };
  }


  function createProofFile() {
    var sources = [loadProofImage(els.productImage.currentSrc || els.productImage.src)];
    if (state.artworkUrl) sources.push(loadProofImage(state.artworkUrl));

    return Promise.all(sources).then(function (images) {
      var canvas = document.createElement("canvas");
      canvas.width = 1200;
      canvas.height = 1400;
      var context = canvas.getContext("2d");
      context.fillStyle = "#071018";
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "#53c6ff";
      context.font = "700 28px Arial, sans-serif";
      context.fillText("ARTWORX DESIGN REQUEST", 60, 58);

      var productBox = drawContained(context, images[0], 100, 90, 1000, 980);
      if (images[1]) {
        var placement = AWPD.placements[state.placement];
        var zoneX = productBox.x + productBox.width * placement.zone.left / 100;
        var zoneY = productBox.y + productBox.height * placement.zone.top / 100;
        var zoneWidth = productBox.width * placement.zone.width / 100;
        var zoneHeight = productBox.height * placement.zone.height / 100;
        var range = placement.absoluteMax - placement.min || 1;
        var visualScale = .35 + Math.max(0, Math.min(1, (state.requestedSize - placement.min) / range)) * .65;
        var artWidth = zoneWidth * visualScale;
        var artHeight = artWidth / (state.artRatio || 1);
        if (placement.dimension === "height") {
          artHeight = zoneHeight * visualScale;
          artWidth = artHeight * (state.artRatio || 1);
        }
        if (artWidth > zoneWidth) {
          artWidth = zoneWidth;
          artHeight = artWidth / (state.artRatio || 1);
        }
        if (artHeight > zoneHeight) {
          artHeight = zoneHeight;
          artWidth = artHeight * (state.artRatio || 1);
        }
        var artX = zoneX + (zoneWidth - artWidth) * state.artX;
        var artY = zoneY + (zoneHeight - artHeight) * state.artY;
        context.drawImage(images[1], artX, artY, artWidth, artHeight);
      }

      context.fillStyle = "#101923";
      context.fillRect(0, 1100, canvas.width, 300);
      context.fillStyle = "#ffffff";
      context.font = "700 26px Arial, sans-serif";
      context.fillText(AWPD.products[state.product].name + (state.color ? " — " + state.color : ""), 60, 1160);
      context.font = "22px Arial, sans-serif";
      context.fillStyle = "#d5e3ea";
      context.fillText("Method: " + (state.method === "embroidery" ? "Embroidery" : "Print"), 60, 1210);
      context.fillText("Placement: " + AWPD.placements[state.placement].name, 60, 1250);
      context.fillText("Requested size: " + state.requestedSize + '"', 60, 1290);
      context.fillText("Quantity: " + getSizeBreakdown().total, 60, 1330);

      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (!blob) {
            reject(new Error("The proof image could not be created."));
            return;
          }
          resolve(new File([blob], "artworx-design-proof.png", { type: "image/png" }));
        }, "image/png");
      });
    });
  }


  function downloadProof(file) {
    var link = document.createElement("a");
    link.href = URL.createObjectURL(file);
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(function () { URL.revokeObjectURL(link.href); }, 1000);
  }


  function bindEvents() {


    els.product.addEventListener(
      "change",
      function () {

        state.product =
          this.value;

        state.color =
          "";


        var allowed =
          getAllowedPlacements();


        var preferred =
          AWPD.products[
            state.product
          ].defaultPlacement;


        state.placement =
          allowed.indexOf(
            preferred
          ) > -1
            ? preferred
            : allowed[0];


        resetArtworkPosition();

        buildColorOptions();

        buildPlacementOptions();

        renderAll();

      }
    );


    els.color.addEventListener(
      "change",
      function () {
        state.color = this.value;
        updateProductImage();
        updateSummaries();
      }
    );



    els.methodRadios.forEach(
      function (radio) {

        radio.addEventListener(
          "change",
          function () {

            state.method =
              this.value;


            buildPlacementOptions();

            resetArtworkPosition();

            renderAll();

          }
        );

      }
    );



    els.sizeRange.addEventListener(
      "input",
      function () {

        state.requestedSize =
          parseFloat(
            this.value
          );


        syncSizeToPlacement();

        updateArtworkSize();

        updatePricingBox();

        updateSummaries();

      }
    );



    els.sizeQtyInputs.forEach(
      function (input) {
        input.addEventListener(
          "input",
          function () {
            var qty = Math.max(0, parseInt(this.value, 10) || 0);
            state.sizeQuantities[this.dataset.size] = qty;
            updateSummaries();
          }
        );
      }
    );



    els.upload.addEventListener(
      "change",
      function () {

        if (
          this.files &&
          this.files[0]
        ) {

          handleUpload(
            this.files[0]
          );

        }

      }
    );



    els.notes.addEventListener(
      "input",
      function () {

        updateSummaries();

      }
    );



    els.resetBtn.addEventListener(
      "click",
      function () {

        state.product =
          els.product.options.length
            ? els.product.options[0].value
            : "tshirt";

        state.color =
          "";


        state.method =
          "print";


        state.placement =
          "center_front";


        state.requestedSize =
          8;


        state.quantity =
          24;

        state.sizeQuantities = {
          S: 0,
          M: 0,
          L: 24,
          XL: 0,
          "2XL": 0,
          "3XL": 0,
          "4XL": 0,
          Other: 0
        };


        state.artworkUrl =
          "";


        state.artworkFileName =
          "";


        state.artRatio =
          1;


        state.artX =
          .5;


        state.artY =
          .5;


        els.product.value =
          state.product;

        buildColorOptions();


        document.getElementById(
          "awpd-method-print"
        ).checked =
          true;


        els.sizeQtyInputs.forEach(
          function (input) {
            input.value = state.sizeQuantities[input.dataset.size] || 0;
          }
        );


        els.upload.value =
          "";


        els.notes.value =
          "";


        els.artwork.src =
          "";


        els.artworkWrap.classList.add(
          "awpd-hidden"
        );


        buildPlacementOptions();

        renderAll();

      }
    );



    els.emailBtn.addEventListener(
      "click",
      async function () {


        var customerName =
          els.name.value ||
          "";


        var company =
          els.company.value ||
          "";


        var customerEmail =
          els.email.value ||
          "";


        var phone =
          els.phone.value ||
          "";

        if (!customerName || !customerEmail || !phone) {
          window.alert("Please enter your name, email, and phone number before creating the proof.");
          return;
        }

        if (!state.artworkUrl) {
          window.alert("Please upload artwork before creating and sending the proof.");
          els.upload.focus();
          return;
        }

        var body =
          els.summaryText.value +

          '\n\n---------------------------------\n' +

          'Customer Name: ' +
          customerName +
          '\n' +

          'Company: ' +
          company +
          '\n' +

          'Customer Email: ' +
          customerEmail +
          '\n' +

          'Phone: ' +
          phone +
          '\n\n' +

          'Send this request and its attached proof to info@artworxprint.com. ' +
          'The proof is a visual request for Artworx review and is not production approval.';


        var subject =

          'Artworx Public Designer Request - ' +

          AWPD.products[
            state.product
          ].name;


        var originalText = els.emailBtn.textContent;
        els.emailBtn.disabled = true;
        els.emailBtn.textContent = "Creating Proof...";

        try {
          var proofFile = await createProofFile();
          var files = [proofFile];
          if (els.upload.files && els.upload.files[0]) files.push(els.upload.files[0]);

          if (navigator.share && navigator.canShare && navigator.canShare({ files: files })) {
            await navigator.share({
              title: subject,
              text: "Please send this Artworx design request to " + AWPD.email + ".\n\n" + body,
              files: files
            });
          } else {
            downloadProof(proofFile);
            var mailto =
              'mailto:' + AWPD.email +
              '?subject=' + encodeURIComponent(subject) +
              '&body=' + encodeURIComponent(body + '\n\nThe PNG proof has downloaded. Please attach it and the original artwork file before sending.');
            window.location.href = mailto;
          }
        } catch (error) {
          console.error("Artworx proof creation failed.", error);
          window.alert("The proof could not be created. Please try again or email your artwork to info@artworxprint.com.");
        } finally {
          els.emailBtn.disabled = false;
          els.emailBtn.textContent = originalText;
        }

      }
    );



    initDragAndResize();

  }



  function initDragAndResize() {


    var dragging =
      false;


    var resizing =
      false;


    var startX =
      0;


    var startY =
      0;


    var startLeft =
      0;


    var startTop =
      0;


    var startWidth =
      0;



    function pointerMove(event) {


      if (
        !state.artworkUrl
      ) {

        return;

      }


      var placement =
        AWPD.placements[
          state.placement
        ];


      if (dragging) {


        var deltaX =
          event.clientX -
          startX;


        var deltaY =
          event.clientY -
          startY;


        var newLeft =
          startLeft +
          deltaX;


        var newTop =
          startTop +
          deltaY;


        var maxLeft =
          els.zone.clientWidth -
          els.artworkWrap.offsetWidth;


        var maxTop =
          els.zone.clientHeight -
          els.artworkWrap.offsetHeight;


        newLeft =
          Math.max(
            0,
            Math.min(
              newLeft,
              maxLeft
            )
          );


        newTop =
          Math.max(
            0,
            Math.min(
              newTop,
              maxTop
            )
          );


        els.artworkWrap.style.left =
          newLeft +
          "px";


        els.artworkWrap.style.top =
          newTop +
          "px";


        state.artX =
          maxLeft > 0
            ? newLeft /
              maxLeft
            : .5;


        state.artY =
          maxTop > 0
            ? newTop /
              maxTop
            : .5;

      }



      if (resizing) {


        var delta =
          event.clientX -
          startX;


        var newWidth =
          startWidth +
          delta;


        var zoneWidth =
          els.zone.clientWidth;


        newWidth =
          Math.max(
            25,
            Math.min(
              newWidth,
              zoneWidth
            )
          );


        var percentage =
          newWidth /
          zoneWidth;


        var newSize =

          placement.min +

          percentage *

          (
            placement.absoluteMax -
            placement.min
          );


        newSize =
          Math.max(
            placement.min,
            Math.min(
              placement.absoluteMax,
              newSize
            )
          );


        newSize =
          Math.round(
            newSize *
            4
          ) /
          4;


        state.requestedSize =
          newSize;


        els.sizeRange.value =
          newSize;


        syncSizeToPlacement();

        updateArtworkSize();

        updatePricingBox();

        updateSummaries();

      }

    }



    function pointerUp() {


      dragging =
        false;


      resizing =
        false;


      document.removeEventListener(
        "pointermove",
        pointerMove
      );


      document.removeEventListener(
        "pointerup",
        pointerUp
      );

    }



    els.artworkWrap.addEventListener(
      "pointerdown",
      function (event) {


        if (
          !state.artworkUrl
        ) {

          return;

        }


        if (
          event.target ===
          els.resizeHandle
        ) {

          return;

        }


        dragging =
          true;


        startX =
          event.clientX;


        startY =
          event.clientY;


        startLeft =
          parseFloat(
            els.artworkWrap.style.left ||
            0
          );


        startTop =
          parseFloat(
            els.artworkWrap.style.top ||
            0
          );


        document.addEventListener(
          "pointermove",
          pointerMove
        );


        document.addEventListener(
          "pointerup",
          pointerUp
        );

      }
    );



    els.resizeHandle.addEventListener(
      "pointerdown",
      function (event) {


        event.preventDefault();

        event.stopPropagation();


        if (
          !state.artworkUrl
        ) {

          return;

        }


        resizing =
          true;


        startX =
          event.clientX;


        startWidth =
          els.artworkWrap.offsetWidth;


        document.addEventListener(
          "pointermove",
          pointerMove
        );


        document.addEventListener(
          "pointerup",
          pointerUp
        );

      }
    );


    els.resizeHandle.addEventListener(
      "keydown",
      function (event) {

        if (!state.artworkUrl) {
          return;
        }

        var direction = 0;

        if (event.key === "ArrowRight" || event.key === "ArrowUp") {
          direction = .25;
        }

        if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
          direction = -.25;
        }

        if (!direction) {
          return;
        }

        event.preventDefault();

        var placement = AWPD.placements[state.placement];

        state.requestedSize = Math.max(
          placement.min,
          Math.min(
            placement.absoluteMax,
            state.requestedSize + direction
          )
        );

        els.sizeRange.value = state.requestedSize;

        syncSizeToPlacement();
        updateArtworkSize();
        updatePricingBox();
        updateSummaries();

      }
    );

  }



  var requestedProductHandle = new URLSearchParams(window.location.search).get("product");
  if (requestedProductHandle) {
    var requestedProductKey = Object.keys(AWPD.products).find(function (key) {
      return AWPD.products[key].handle === requestedProductHandle;
    });
    if (requestedProductKey && els.product.querySelector('option[value="' + requestedProductKey + '"]')) {
      state.product = requestedProductKey;
      els.product.value = requestedProductKey;
    }
  }

  if (AWPD.products[state.product]) {
    state.placement = AWPD.products[state.product].defaultPlacement;
  }

  buildColorOptions();

  buildPlacementOptions();

  bindEvents();

  renderAll();



  window.addEventListener(
    "resize",
    function () {

      updateArtworkSize();

    }
  );


})();

